import React, { useState } from 'react';
import PurchaseListTemplate from '../../../pages/purchase/components/PurchaseListTemplate';
import { PurchaseTabScene, PurchaseInfo, PurchaseStatus } from '../../../types/process/purchase';
import { useDefaultQueryFields } from '../../../pages/purchase/purchase.effect';
import PurchaseTriggerActionMap, { PurchaseTriggerActionProvider, PurchaseTriggerTarget } from '../../../pages/purchase/components/PurchaseTriggerActionMap';

const PurchaseDeliveryPendingList: React.FC = () => {
  const [refreshKey, setRefreshKey] = useState(0);
  const reloadList = () => setRefreshKey(k => k + 1);
  const queryFields = useDefaultQueryFields(PurchaseTabScene.DeliveryPending);

  const renderTableActions = (order: PurchaseInfo) => {
    const targets: PurchaseTriggerTarget[] = [];
    if (order.purchase.status === PurchaseStatus.Undeclared || order.purchase.status === PurchaseStatus.Declared) {
      targets.push('generateSignature');
    }
    
    return <PurchaseTriggerActionMap targets={targets} purchase={order} onReload={reloadList} />;
  };

  return (
    <PurchaseTriggerActionProvider onReload={reloadList}>
      <PurchaseListTemplate
        title="微签管理"
        refreshKey={refreshKey}
        queryFields={queryFields}
        tabScene={PurchaseTabScene.DeliveryPending}
        defaultScene={PurchaseTabScene.DeliveryPending}
        viewModes={React.useMemo(() => [
          {
            mode: 'table' as const,
            label: '表格页',
            renderActions: renderTableActions,
            showField: 'tab_delivery_pending'
          }
        ], [renderTableActions])}
      />
    </PurchaseTriggerActionProvider>
  );
};

export default PurchaseDeliveryPendingList;
